import { Router } from "./Router";
import { Nav } from "./Nav";

import type { Route } from "./Router";

import { nav, md } from "./styles";
import {
  AsyncInit,
  NGSModule,
  NGSModuleMetadata,
  SyncInit,
} from "~/core/module";
import { NGSModules } from "../registry";

export class Handbook extends NGSModule {
  protected meta(): NGSModuleMetadata {
    return NGSModules.handbook;
  }
  root = document.getElementById("content");
  navRoot = document.getElementById("side-nav");

  routes: Route[] = [
    {
      path: "/",
      index: true,
      ext: "md",
      content: null,
      navOptions: {
        ignoreSections: true,
      },
    },
    {
      path: "/r&g",
      ext: "md",
      pathAlias: "guidelines",
      navOptions: { ignoreSections: true },
    },
    { path: "/first-flight", ext: "md" },
    { path: "/awards", ext: "md" },
    { path: "/acars", pathAlias: "acars", ext: "md" },
    { path: "/privacy", ext: "md", navOptions: { ignoreSections: true } },
  ];

  router = new Router(this.routes, this.root, "/handbook");

  sidebar = new Nav(this.navRoot, this.router);

  async init(): Promise<void> {
    this.sidebar.init({ title: "NGS Handbook", styles: nav });

    await this.router.init({ markdownStyle: md });
    // Hydrate side nav with route content
    this.sidebar.hydrate(this.router.allRoutes);

    // Done loading! Remove spinners
    document.querySelectorAll(".loader").forEach((e) => e.remove());
  }

  destroy(): void {}
}
